import { post, get, request } from "./http.js";
//公共接口
/**
 * 登录接口
 * @param {*} data 
 * @returns 
 */
const indexLogin = (data) => post("index/login", data);
/**
 * 上传文件
 * @param {*} data 
 * @returns 
 */
const indexUploadfile = (data) => post("index/uploadfile", data);
/**
 * 首页统计数据
 * @param {*} data 
 * @returns 
 */
const indexHome = (data) => post("index/home", data);
/**
 * 方案按照日期统计
 * @param {*} data 
 * @returns 
 */
const indexSchemeaddup = (data) => post("index/schemeaddup", data);
/**
 * 设备统计
 * @param {*} data 
 * @returns 
 */
const indexDeviceaddup = (data) => post("index/deviceaddup", data);
/**
 * 方案管理 列表
 * @param {*} data 
 * @returns 
 */
const indexSchemelist = (data) => post("index/schemelist", data);

/**
 * 方案管理 设置方案有效无效
 * @param {*} data 
 * @returns 
 */
const indexSetschemestatus = (data) => post("index/setschemestatus", data);
/**
 * 方案管理 添加收藏
 * @param {*} data 
 * @returns 
 */
const indexSetcollect = (data) => post("index/setcollect", data);
/**
 * 模型管理 模型类别
 * @param {*} data 
 * @returns 
 */
const indexModelcatelist = (data) => post("index/modelcatelist", data);
/**
 * 模型管理 模型类型新增编辑
 * @param {*} data 
 * @returns 
 */
const indexEditmodelcate = (data) => post("index/editmodelcate", data);
/**
 * 模型管理 模型类型重新排序
 * @param {*} data 
 * @returns 
 */
const indexModelcateorder = (data) => post("index/modelcateorder", data);
/**
 * 模型管理 模型类型删除
 * @param {*} data 
 * @returns 
 */
const indexDelmodelcate = (data) => post("index/delmodelcate", data);
/**
 * 模型管理 根据模型分类得到模型数据
 * @param {*} data 
 * @returns 
 */
const indexModellist = (data) => post("index/modellist", data);
/**
 * 模型管理 新增模型文件
 * @param {*} data 
 * @returns 
 */
const indexUploadmodel = (data) => post("index/uploadmodel", data);
/**
 * 模型管理 编辑模型数据
 * @param {*} data 
 * @returns 
 */
const indexEditmodel = (data) => post("index/editmodel", data);
/**
 * 模型管理 标签绑定
 * @param {*} data 
 * @returns 
 */
const indexLabelbind = (data) => post("index/labelbind", data);
/**
 * 模型管理 模型删除
 * @param {*} data 
 * @returns 
 */
const indexDelmodel = (data) => post("index/delmodel", data);
/**
 * 绑定 获取组件模型各级类型
 * @param {*} data 
 * @returns 
 */
const indexGetmodelcate = (data) => post("index/getmodelcate", data);
/**
 * 绑定 得到组件模型分类 （tab切换栏）
 * @param {*} data 
 * @returns 
 */
const indexGetmodulemodelcate = (data) => post("index/getmodulemodelcate", data);
/**
 * 绑定 组件模型分类tab栏新增编辑
 * @param {*} data 
 * @returns 
 */
const indexEditmodulemodelcate = (data) => post("index/editmodulemodelcate", data);
/**
 * 绑定 组件模型分类tab栏删除
 * @param {*} data 
 * @returns 
 */
const indexDelmodulemodelcate = (data) => post("index/delmodulemodelcate", data);
/**
 * 绑定 得到绑定列表
 * @param {*} data 
 * @returns 
 */
const indexBindlist = (data) => post("index/bindlist", data);
/**
 * 绑定 提交绑定
 * @param {*} data 
 * @returns 
 */
const indexSetbind = (data) => post("index/setbind", data);
/**
 * 帮助管理 帮助新增编辑
 * @param {*} data 
 * @returns 
 */
const indexHelpedit = (data) => post("index/helpedit", data);
/**
 * 帮助管理 列表
 * @param {*} data 
 * @returns 
 */
const indexHelplist = (data) => post("index/helplist", data);
/**
 * 帮助管理 删除
 * @param {*} data 
 * @returns 
 */
const indexHelpdel = (data) => post("index/helpdel", data);
/**
 * 帮助管理 详情
 * @param {*} data 
 * @returns 
 */
const indexHelpdetail = (data) => post("index/helpdetail", data);
/**
 * 收藏管理 列表
 * @param {*} data 
 * @returns 
 */
const indexCollectlist = (data) => post("index/collectlist", data);
/**
 * 收藏管理 设置收藏方案发布 下架
 * @param {*} data 
 * @returns 
 */
const indexSetcollectstatus = (data) => post("index/setcollectstatus", data);
/**
 * 收藏管理 编辑收藏方案
 * @param {*} data 
 * @returns 
 */
const indexEditcollect = (data) => post("index/editcollect", data);

/**
 * 收藏管理 方案文件批量压缩
 * @param {*} data 
 * @returns 
 */
const indexSchemecompress = (data) => post("index/schemecompress", data);
export default {
    indexSchemecompress,
    indexCollectlist,
    indexSetcollectstatus,
    indexEditcollect,
    indexHome,
    indexSchemeaddup,
    indexDeviceaddup,

    indexHelpedit,
    indexHelplist,
    indexHelpdel,
    indexHelpdetail,
    indexSetschemestatus,
    indexLogin,
    indexUploadfile,
    indexSchemelist,
    indexSetcollect,
    indexModelcatelist,
    indexEditmodelcate,
    indexModelcateorder,
    indexDelmodelcate,
    indexModellist,
    indexUploadmodel,
    indexEditmodel,
    indexLabelbind,
    indexDelmodel,
    indexGetmodelcate,
    indexGetmodulemodelcate,
    indexEditmodulemodelcate,
    indexDelmodulemodelcate,
    indexBindlist,
    indexSetbind
}